import React from "react";
import LoadingOverlay from "react-loading-overlay";
import PuffLoader from "react-spinners/PuffLoader";

import "./LoadingOverlay.css";

const loaderCSS = `
display: block;
margin: 0 auto;
`;

const loadingOverlay = (props) => (
  <LoadingOverlay
    active={props.isActive}
    spinner={props.spinner ?? <PuffLoader color={"#ffffff"} css={loaderCSS} />}
    text={props.text ?? "Working on it..."}
  >
    {props.children}
  </LoadingOverlay>
);

export default loadingOverlay;
